/* GTM dataLayer events for the upgrade funnel.
 *
 * Every event here is either delegated off `document` or driven by the theme's
 * own pubsub, so the tracked components are never modified -- they just carry
 * `data-ga-*` attributes. Container GTM-NHN3LXN picks these pushes up; the GA4
 * tags and triggers live in GTM, not here.
 *
 * Loaded after constants.js and pubsub.js in theme.liquid, so PUB_SUB_EVENTS
 * and subscribe() are available by the time this runs.
 */
(function () {
  /* Attribution survives a navigation, so it has to outlive the page. Session
     storage keeps it per-tab and clears itself when the tab closes. */
  var ATTRIBUTION_KEY = 'aprilaire:upgrade-attribution';
  var ATTRIBUTION_TTL = 30 * 60 * 1000;

  window.dataLayer = window.dataLayer || [];

  /* Blank params are dropped rather than sent as empty strings -- GA4 reports
     read much better with the key absent than with "(not set)" rows. */
  function push(eventName, params) {
    var payload = { event: eventName, page_location: window.location.href };

    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];

      if (value !== null && value !== undefined && value !== '') {
        payload[key] = value;
      }
    });

    window.dataLayer.push(payload);
  }

  function currency() {
    return (
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      null
    );
  }

  function money(cents) {
    var amount = parseInt(cents, 10);

    return isNaN(amount) ? null : amount / 100;
  }

  function setAttribution(via, detail, handle) {
    try {
      sessionStorage.setItem(
        ATTRIBUTION_KEY,
        JSON.stringify({
          via: via,
          detail: detail,
          handle: handle,
          ts: Date.now(),
        })
      );
    } catch (e) {
      /* Private mode / storage disabled -- attribution is best effort. */
    }
  }

  function getAttribution() {
    try {
      var raw = sessionStorage.getItem(ATTRIBUTION_KEY);

      if (!raw) return null;

      var data = JSON.parse(raw);

      if (!data || !data.ts || Date.now() - data.ts > ATTRIBUTION_TTL)
        return null;

      return data;
    } catch (e) {
      return null;
    }
  }

  /* Locale-prefixed paths (/en-ca/collections/...) are live on this store, so
     match on the segment rather than anchoring at the start of the path. */
  function listContext() {
    var path = window.location.pathname;
    var collection = path.match(/\/collections\/([^/?#]+)/);

    if (collection) {
      return { type: 'collection', detail: decodeURIComponent(collection[1]) };
    }

    if (/\/search\/?$/.test(path)) {
      var query = '';

      try {
        query = new URLSearchParams(window.location.search).get('q') || '';
      } catch (e) {
        query = '';
      }

      return { type: 'search', detail: query };
    }

    return null;
  }

  /* 1-based index of the card within its grid, for click-position reporting. */
  function cardPosition(card) {
    var item = card && card.closest('li');

    if (!item || !item.parentElement) return null;

    return Array.prototype.indexOf.call(item.parentElement.children, item) + 1;
  }

  function handleFromUrl(url) {
    var match = (url || '').match(/\/products\/([^/?#]+)/);

    return match ? match[1] : null;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    /* closest() lives on Element -- a click whose target isn't one would throw
       and take the whole delegated handler down with it. */
    if (!target || !target.closest) return;

    /* Recommended Upgrade video -- fires on the play click. Once the YouTube
       iframe takes over we can't see engagement, so this is play intent only. */
    var poster = target.closest('[data-ga-video-name]');

    if (poster) {
      push('upgrade_video_play', {
        video_name: poster.dataset.gaVideoName,
        video_host: poster.dataset.gaVideoHost,
        product_sku: poster.dataset.gaProductSku,
        replacement_sku: poster.dataset.gaReplacementSku,
      });

      return;
    }

    /* PDP-to-PDP upgrade click -- the "UPGRADE NOW" button or the replacement
       product title. Both are links, so this also seeds the attribution that
       add_to_cart_attributed reads on the next page. */
    var upgrade = target.closest('[data-ga-upgrade-source]');

    if (upgrade) {
      var buttonName =
        upgrade.dataset.gaButtonName || upgrade.dataset.gaReplacementSku || '';

      push('upgrade_click', {
        click_source: upgrade.dataset.gaUpgradeSource,
        button_name: buttonName,
        button_label: (upgrade.textContent || '').trim().slice(0, 100),
        product_sku: upgrade.dataset.gaProductSku,
        replacement_sku: upgrade.dataset.gaReplacementSku,
        replacement_handle: upgrade.dataset.gaReplacementHandle,
      });

      setAttribution(
        'upgrade_button',
        buttonName,
        upgrade.dataset.gaReplacementHandle
      );

      return;
    }

    /* Product click on a collection or search page. Quick-add lives inside the
       card, but it's a <button>, so the link selector already skips it -- the
       guard only covers product links inside an open quick-add modal. */
    var productLink = target.closest('a[href*="/products/"]');

    if (
      !productLink ||
      target.closest('quick-add-modal, .quick-add, .quick-add-bulk')
    )
      return;

    var list = listContext();

    if (!list) return;

    var card = productLink.closest('[data-ga-product-handle]');
    var handle =
      (card && card.dataset.gaProductHandle) ||
      handleFromUrl(productLink.getAttribute('href'));

    push('collection_product_click', {
      list_type: list.type,
      list_detail: list.detail,
      product_handle: handle,
      product_sku: card && card.dataset.gaProductSku,
      product_title: card && card.dataset.gaProductTitle,
      position: cardPosition(card),
    });

    setAttribution(list.type, list.detail, handle);
  });

  /* Cart-page upgrade swap. cart.js rebuilds .js-contents on every cart update,
     so this is delegated rather than bound to the element. Fires on click, which
     is what was specced -- the swap itself is async and can still fail. */
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var action = event.target.closest('.cart-upgrade__action');
    var upgrade = action && action.closest('cart-upgrade');

    if (!upgrade) return;

    push('cart_swap_clicked', {
      original_sku: upgrade.dataset.gaOriginalSku,
      original_product_title: upgrade.dataset.gaOriginalTitle,
      original_variant_title: upgrade.dataset.gaOriginalVariant,
      original_quantity:
        parseInt(upgrade.dataset.gaOriginalQuantity, 10) || null,
      new_sku: upgrade.dataset.gaNewSku,
      new_product_title: upgrade.dataset.gaNewTitle,
      new_variant_title: upgrade.dataset.gaNewVariant,
      new_price: money(upgrade.dataset.gaNewPrice),
      currency: currency(),
    });
  });

  /* Attributed add-to-cart. product-form.js already publishes cartUpdate on a
     successful add and it backs both the PDP form and quick-add, so no
     add-to-cart code needs touching. Other sources (cart-items, quick-order-
     list) publish the same event for quantity edits and are filtered out. */
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;

      var data = event.cartData;

      if (!data) return;

      /* /cart/add.js returns the line item itself for a single-variant add and
         an `items` array for a multi-add. */
      var item = data.items && data.items.length ? data.items[0] : data;

      if (!item || !item.key) return;

      var attribution = getAttribution();

      if (!attribution) return;

      /* Only attribute the product the visitor actually landed on -- otherwise
         an unrelated add later in the session would inherit the credit. */
      if (
        attribution.handle &&
        item.handle &&
        attribution.handle !== item.handle
      )
        return;

      push('add_to_cart_attributed', {
        landed_via: attribution.via,
        landed_via_detail: attribution.detail,
        landed_via_age_seconds: Math.round(
          (Date.now() - attribution.ts) / 1000
        ),
        product_sku: item.sku,
        product_handle: item.handle,
        product_title: item.product_title,
        variant_title: item.variant_title,
        quantity: item.quantity,
        value: money(item.price),
        currency: currency(),
      });
    });
  }
})();
